/* ==========================================================================
   Craft Logic — theme scripts
   No dependencies. Uses Shopify's AJAX Cart API.
   ========================================================================== */

(function () {
  'use strict';

  var money = function (cents) {
    var format = window.CraftLogic && window.CraftLogic.moneyFormat ? window.CraftLogic.moneyFormat : '£{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  };

  /* ---------------------------------------------------------------- Reveal */

  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------ Mobile nav */

  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var openers = document.querySelectorAll('[data-mobile-nav-open]');
    var closers = nav.querySelectorAll('[data-mobile-nav-close]');

    function open() {
      nav.setAttribute('data-open', 'true');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.classList.add('no-scroll');
      var first = nav.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      nav.setAttribute('data-open', 'false');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (openers[0]) openers[0].focus();
      document.body.classList.remove('no-scroll');
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') close();
    });
  }

  /* ---------------------------------------------------------- Cart drawer */

  var Drawer = {
    el: null,
    overlay: null,
    body: null,
    foot: null,

    init: function () {
      this.el = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-drawer-overlay]');
      if (!this.el) return;
      this.body = this.el.querySelector('[data-drawer-body]');
      this.foot = this.el.querySelector('[data-drawer-foot]');

      var self = this;
      this.el.querySelectorAll('[data-drawer-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });

      document.querySelectorAll('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (!window.CraftLogic || !window.CraftLogic.cartDrawer) return;
          e.preventDefault();
          self.refresh().then(function () { self.open(); });
        });
      });
    },

    open: function () {
      if (!this.el) return;
      this.el.setAttribute('data-open', 'true');
      if (this.overlay) this.overlay.setAttribute('data-open', 'true');
      document.body.classList.add('no-scroll');
    },

    close: function () {
      if (!this.el) return;
      this.el.setAttribute('data-open', 'false');
      if (this.overlay) this.overlay.setAttribute('data-open', 'false');
      document.body.classList.remove('no-scroll');
    },

    refresh: function () {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (self.body) self.body.innerHTML = self.renderItems(cart);
          if (self.foot) self.foot.innerHTML = self.renderFoot(cart);
          self.bindLines();
          return cart;
        })
        .catch(function () {});
    },

    renderItems: function (cart) {
      if (!cart.items.length) {
        return '<p style="padding:2.5rem 0;text-align:center;">' + (window.CraftLogic.strings.cartEmpty || 'Your basket is empty.') + '</p>';
      }
      return cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_200x$1') + '" alt="" width="200" height="200" loading="lazy">'
          : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<div class="cart-line__variant">' + item.variant_title + '</div>' : '';
        return '' +
          '<div class="cart-line" data-line-key="' + item.key + '">' +
            '<div class="cart-line__media">' + img + '</div>' +
            '<div>' +
              '<a class="cart-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
              variant +
              '<div class="cart-line__variant">' + money(item.final_line_price) + ' · ' + item.quantity + '</div>' +
              '<button type="button" class="cart-line__remove" data-line-remove="' + item.key + '">' +
                (window.CraftLogic.strings.remove || 'Remove') +
              '</button>' +
            '</div>' +
          '</div>';
      }).join('');
    },

    renderFoot: function (cart) {
      if (!cart.items.length) {
        return '<a class="btn btn--full" href="' + window.Shopify.routes.root + 'collections/all">' +
          (window.CraftLogic.strings.continueShopping || 'Continue shopping') + '</a>';
      }
      return '' +
        '<div class="cart-summary__row">' +
          '<span class="note">' + (window.CraftLogic.strings.subtotal || 'Subtotal') + '</span>' +
          '<span class="cart-summary__total">' + money(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="note" style="margin-bottom:1rem;">' + (window.CraftLogic.strings.taxNote || '') + '</p>' +
        '<form action="' + window.Shopify.routes.root + 'cart" method="post">' +
          '<button type="submit" name="checkout" class="btn btn--full btn--lg">' +
            (window.CraftLogic.strings.checkout || 'Checkout') +
          '</button>' +
        '</form>' +
        '<a class="link-underline" style="margin-top:1rem;display:inline-flex;" href="' + window.Shopify.routes.root + 'cart">' +
          (window.CraftLogic.strings.viewCart || 'View basket') + '</a>';
    },

    bindLines: function () {
      var self = this;
      if (!this.body) return;
      this.body.querySelectorAll('[data-line-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-line-remove');
          fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function () { self.refresh(); });
        });
      });
    }
  };

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ----------------------------------------------------------- Add to cart */

  function initAddToCart() {
    document.querySelectorAll('form[data-product-form], form.product-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.CraftLogic || !window.CraftLogic.cartDrawer) return; // let it post normally
        e.preventDefault();
        var btn = form.querySelector('[data-add-button]');
        var allButtons = document.querySelectorAll('form.product-form [data-add-button], form[data-product-form] [data-add-button]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = '…'; }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message);
            return Drawer.refresh();
          })
          .then(function () { Drawer.open(); })
          .catch(function (err) {
            var box = form.querySelector('[data-form-error]');
            if (box) { box.textContent = err.message; box.hidden = false; }
          })
          .finally(function () {
            if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = original; }
          });
      });
    });
  }

  /* ------------------------------------------------------- Quantity widget */

  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* --------------------------------------------------------- Variant picker */

  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = document.querySelector('form.product-form') || document.querySelector('form[data-product-form]');
      var data = document.querySelector('[data-variant-json="' + picker.getAttribute('data-variant-picker') + '"]');
      if (!data || !form) return;
      var variants = JSON.parse(data.textContent);

      function currentOptions() {
        return Array.prototype.map.call(
          picker.querySelectorAll('fieldset'),
          function (set) {
            var checked = set.querySelector('input:checked');
            return checked ? checked.value : null;
          }
        );
      }

      function update() {
        var chosen = currentOptions();
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });

        var btn = form.querySelector('[data-add-button]');
        var allButtons = document.querySelectorAll('form.product-form [data-add-button], form[data-product-form] [data-add-button]');
        var priceEl = document.querySelector('[data-price-target]');

        if (!match) {
          allButtons.forEach(function (button) { button.disabled = true; button.textContent = window.CraftLogic.strings.unavailable; });
          if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = window.CraftLogic.strings.unavailable; }
          return;
        }
        // Keep every add-to-cart form on the page (incl. the sticky bar) in sync
        document.querySelectorAll('form.product-form [name="id"], form[data-product-form] [name="id"]')
          .forEach(function (input) { input.value = match.id; });
        if (priceEl) {
          priceEl.innerHTML = match.compare_at_price && match.compare_at_price > match.price
            ? '<s>' + money(match.compare_at_price) + '</s>' + money(match.price)
            : money(match.price);
        }
        if (btn) {
          if (match.available) {
            btn.removeAttribute('disabled');
            btn.textContent = window.CraftLogic.strings.addToCart;
          } else {
            btn.setAttribute('disabled', 'disabled');
            btn.textContent = window.CraftLogic.strings.soldOut;
          }
        }
        allButtons.forEach(function (button) { button.disabled = !match.available; button.textContent = match.available ? window.CraftLogic.strings.addToCart : window.CraftLogic.strings.soldOut; });
        var stickyPrice = document.querySelector('[data-sticky-bar] .sticky-bar__price .sticky-bar__title');
        if (stickyPrice) stickyPrice.textContent = money(match.price);
        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* ------------------------------------------------------- Bundle selector */

  function initBundleSelector() {
    document.querySelectorAll('[data-bundle-selector]').forEach(function (selector) {
      if (selector.getAttribute('data-bundle-ready') === 'true') return;
      selector.setAttribute('data-bundle-ready', 'true');

      var sectionId = selector.getAttribute('data-section-id');
      var hero = document.getElementById('V3ProductHero-' + sectionId);
      if (!hero) return;

      var mainForm = hero.querySelector('form.product-form');
      var priceEl = hero.querySelector('[data-price-target]');
      var mainId = mainForm ? mainForm.querySelector('input[name="id"]') : null;
      var mainQty = mainForm ? mainForm.querySelector('input[name="quantity"]') : null;
      var mainButton = mainForm ? mainForm.querySelector('[data-add-button]') : null;
      var express = hero.querySelector('.v3-dynamic-checkout');
      var sticky = document.querySelector('[data-sticky-bar][data-section-id="' + sectionId + '"]');
      var stickyId = sticky ? sticky.querySelector('input[name="id"]') : null;
      var stickyQty = sticky ? sticky.querySelector('input[name="quantity"]') : null;
      var stickyButton = sticky ? sticky.querySelector('[data-add-button]') : null;
      var stickyPrice = sticky ? sticky.querySelector('.sticky-bar__price .sticky-bar__title') : null;

      function setButton(button, available) {
        if (!button) return;
        button.disabled = !available;
      }

      function apply(input) {
        if (!input) return;
        var id = input.getAttribute('data-bundle-variant');
        var price = parseInt(input.getAttribute('data-bundle-price') || '0', 10);
        var compare = parseInt(input.getAttribute('data-bundle-compare') || '0', 10);
        var available = input.getAttribute('data-bundle-available') === 'true';
        var kind = input.getAttribute('data-bundle-kind') || 'single';

        if (mainId && id) mainId.value = id;
        if (stickyId && id) stickyId.value = id;
        if (mainQty) mainQty.value = 1;
        if (stickyQty) stickyQty.value = 1;

        if (priceEl && price) {
          priceEl.innerHTML = compare > price
            ? '<s>' + money(compare) + '</s>' + money(price)
            : money(price);
        }
        if (stickyPrice && price) stickyPrice.textContent = money(price);

        setButton(mainButton, available);
        setButton(stickyButton, available);

        // Shopify's dynamic checkout button is rendered server-side for the
        // original product, so only show it while the single-kit option is selected.
        if (express) express.hidden = kind !== 'single';
      }

      selector.addEventListener('change', function (event) {
        var input = event.target.closest('input[data-bundle-variant]');
        if (input) apply(input);
      });

      apply(selector.querySelector('input[data-bundle-variant]:checked'));
    });
  }

  /* -------------------------------------------------------------- Gallery */

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main] img');
      if (!main) return;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-full');
          if (src) { main.removeAttribute('srcset'); main.setAttribute('src', src); main.alt = thumb.getAttribute('aria-label') || ''; }
          gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ----------------------------------------------------------- Sticky bar */

  function initStickyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passedPurchaseControls = !entry.isIntersecting && entry.boundingClientRect.bottom < 90;
        bar.setAttribute('data-visible', passedPurchaseControls ? 'true' : 'false');
      });
    }, { rootMargin: '-90px 0px 0px 0px' });
    io.observe(anchor);
  }

  /* -------------------------------------------------------------- Sorting */

  function initSort() {
    var select = document.querySelector('[data-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ----------------------------------------------------------------- Init */

  function boot() {
    window.CraftLogic = window.CraftLogic || {};
    window.CraftLogic.strings = window.CraftLogic.strings || {};
    if (!window.Shopify) window.Shopify = {};
    if (!window.Shopify.routes) window.Shopify.routes = { root: '/' };

    initReveal();
    initMobileNav();
    Drawer.init();
    initAddToCart();
    initQuantity();
    initVariants();
    initBundleSelector();
    initGallery();
    initStickyBar();
    initSort();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', boot);
})();
